import React, { useState } from "react";

// component
import LinkModal from './LinkModal';

// mui
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

// icons
import LinkIcon from '@mui/icons-material/Link';


const LinkButton = () => {
    // メニューの開閉
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ButtonGroup
                size="small"
                aria-label="small button group"
                sx={{
                    [`& .MuiButtonBase-root`]: {
                        borderColor: (theme) => theme.palette.grey[400],
                        color: (theme) => theme.palette.grey[600],

                    },
                    [`& .MuiSvgIcon-root`]: {
                        fontSize: 18,
                    },
                }}
            >
                <Button
                    onClick={(event) => {
                        event.preventDefault();
                        handleClick(event);
                    }}
                >
                    <LinkIcon />
                </Button>
            </ButtonGroup>
            <LinkModal
                anchorEl={anchorEl}
                handleClose={handleClose}
                isOpen={open}
            />
        </>
    );
};

export default LinkButton;
    